import { render, staticRenderFns } from "./progress_quickView.vue?vue&type=template&id=2aaf926a"
import script from "./progress_quickView.vue?vue&type=script&lang=js"
export * from "./progress_quickView.vue?vue&type=script&lang=js"
import style0 from "./progress_quickView.vue?vue&type=style&index=0&id=2aaf926a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports